import { migration417Demos } from './4.1.7-demos';

export const migrations = [migration417Demos];
